// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const RefreshControl = createStyle({});
